import { render } from "./Sync.vue?vue&type=template&id=91a5ddb2"
import script from "./Sync.vue?vue&type=script&lang=ts"
export * from "./Sync.vue?vue&type=script&lang=ts"
script.render = render

export default script